import { render, staticRenderFns } from "./PDFWhite.vue?vue&type=template&id=35982354"
import script from "./PDFWhite.vue?vue&type=script&lang=js"
export * from "./PDFWhite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports